﻿import Constant from 'utils/constants';

export const isRejected = ({state}) => state === Constant.treatmentPlan.state.rejected;
export const isAccepted = ({state}) => state === Constant.treatmentPlan.state.accepted;
export const isPublished = ({state}) => state === Constant.treatmentPlan.state.published;
export const isDraft = ({state}) => state === Constant.treatmentPlan.state.drafted;
